import React from "react";
import "./ModalMesaClick.css";

const ModalMesaClick = ({ open, onClose, title = "Mensagem", message }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick"
          className="modal-logo"
        />

        
        <p className="modal-message">{message}</p>

        <button className="modal-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default ModalMesaClick;
